import React, { Component } from 'react'
import styles from "./Analytics.module.css"
import ChevronRightIcon from '../svgs/ChevronRightIcon'
import { rwbApi } from '../../../../shared/apis/api';
import { withRouter } from 'react-router-dom';
import Header from '../Header';
import Loading from '../Loading';
class Analytics extends Component {
    constructor(props) {
        super(props)
        this.state = {
            analytics: [],
            active_users_last_30_days: 0,
            challenges: [],
            events: [],
            total_registrations: 0,
            workspace_id: 0,
            workspace_name: '',
            startDate: '',
            endDate: '',
            isLoading: false,
        }
    }
    componentDidMount() {
        this.fetchAnalytics();
    }

    fetchAnalytics = () => {
        this.setState({ isLoading: true, analytics: [], fetched_analytics: [] });
        rwbApi.getUsageAnalytics({startDate: this.state.startDate, endDate: this.state.endDate, forceRefresh: this.state.startDate || this.state.endDate})
            .then((analytics) => {
                analytics = analytics['workspaces'];
                this.setState({
                    fetched_analytics: analytics,
                    isLoading: false,
                })
            })
            .catch((error) => {
                console.error(error);
                this.setState({ isLoading: false });
            });
    };
    navigateWorkspaceAnalytics =(analyticsItem) =>{
        this.props.history.push({
            pathname: `/workspaceanalytics`,
            state: {workSpace: analyticsItem, startDate: this.state.startDate, endDate: this.state.endDate},
          });
    }

    renderSingleEntry(fetchedAnalyticsItem) {
        const { active_users_last_30_days, challenges, events, total_registrations, workspace_name } = fetchedAnalyticsItem
        const totalChallengesParticipants = challenges.reduce((sum, current) => sum + current.total_participants, 0);
        const totalEventsParticipants = events.reduce((sum, current) => sum + current.total_participants, 0);

        return (
            <>
                <div onClick={() => {this.navigateWorkspaceAnalytics(fetchedAnalyticsItem)}} className={styles.analyticsBlock}>
                    <h1 className={[styles.analyticsHeader]}>
                        {workspace_name}
                        <ChevronRightIcon />
                    </h1>
                    <div className={`${styles.statsContainer} ${styles.mini}`}>
                        <div className={`${styles.statbox} ${styles.mini}`}>
                            <h2>{total_registrations}</h2>
                            <p>Total Users</p>
                        </div>
                        <div className={`${styles.statbox} ${styles.mini}`}>
                            <h2>{active_users_last_30_days}</h2>
                            <p>Active Users</p>
                            
                        </div>                    
                    </div>
                </div>
            </>
        )
    }

    render() {

        const fetched_analytics = this.state.fetched_analytics;
        const {history} = this.props

        return (
            <div>
                {this.state.isLoading && <Loading size={100} color={'var(--white)'} loading={true} />}
                <Header title={"Analytics"} onBack={() => {history.goBack() }} />
                <div className={styles.dateRangeContainer}>
                    <h4>Start Date</h4>
                    <input
                        type="date"
                        value={this.state.startDate}
                        onChange={(e) => this.setState({ startDate: e.target.value })}
                        max={this.state.endDate ? new Date(this.state.endDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                    />
                    <h4>End Date</h4>
                    <input
                        type="date"
                        value={this.state.endDate}
                        onChange={(e) => this.setState({ endDate: e.target.value })}
                        min={this.state.startDate ? new Date(this.state.startDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                    />
                    <button onClick={() => {
                        const hasFormerStartOrEndDate = this.state.startDate || this.state.endDate;
                        if (hasFormerStartOrEndDate) {    
                            this.setState({ startDate: '', endDate: '' }, () => {
                                this.fetchAnalytics();
                            })
                        }
                    }}>Clear</button>
                    <button disabled={!this.state.startDate && !this.state.endDate} onClick={() => this.fetchAnalytics()}>Fetch by Date Range</button>
                </div>
                <div className={[styles.contentContainer]}>
                    
                    { fetched_analytics && fetched_analytics.map((item, index) => (
                        <div key={index} style={{ marginBottom: '20px' }} >
                            { this.renderSingleEntry(item) }
                        </div>
                    )) }
                </div>
            </div>
        )
    }
}

export default withRouter(Analytics)